import { render, staticRenderFns } from "./viewNoticeDetailNew.vue?vue&type=template&id=15617a46&scoped=true"
import script from "./viewNoticeDetailNew.vue?vue&type=script&lang=js"
export * from "./viewNoticeDetailNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15617a46",
  null
  
)

export default component.exports